export class AgentInfo {
	public iataCode : String;
	public status : Number;
	public userId : string;	
	public firstname : String;
	public lastName : String;
	public address1 : String;
	public address2 : String;	
	public city : String;
	public state : String;
	public country : String;
	public zipCode : Number;
	public phone : Number;
	public phoneCode : Number;
	public mobile : Number;
	public emailId : String;
	public modifyFlag:boolean;
	public travelAgentStatus:String;
	public isUserActive:boolean;
	constructor(obj ?: Object) {
		if(obj) {
			this.iataCode = obj['iataCode'] || '';
			this.status = obj['status'] || '';
			this.userId = obj['userId'] || '';
			this.firstname = obj['firstname'] || '';
			this.lastName = obj['lastName'] || '';
			this.address1 = obj['address1'] || '';
			this.address2 = obj['address2'] || '';
			this.city = obj['city'] || '';
			this.state = obj['state'] || '';
			this.country = obj['country'] || '';
			this.zipCode = obj['zipCode'] || '';
			this.phone = obj['phone'] || '';
			this.phoneCode = obj['phoneCode'] || '';
			this.mobile = obj['mobile'] || '';
			this.emailId = obj['emailId'] || '';
			this.isUserActive = obj['isUserActive'] || '';
		}
	}
}

export class AgentList {
	public iataCode : String;
	public userId : string;
	public username : String;
	public country : String;
	public firstName : String;
	public address : String;
	public address1 : String;
	public city : String;
	public emailAddress : String;
	public lastName : String;
	public postalCode : Number;
	public state : String;
	public status : Number;	
	public telephoneNumber : Number;
	public mobileNumber : Number;
    public isUserActive:boolean;
	constructor(obj ?: Object) {
		if(obj) {
			this.iataCode = obj['iataCode'] || '';
			this.userId = obj['userId'] || '';
			this.username = obj['username'] || '';
			this.country = obj['country'] || '';
			this.firstName = obj['firstName'] || '';
			this.address = obj['address'] || '';
			this.address1 = obj['address1'] || '';
			this.city = obj['city'] || '';
			this.emailAddress = obj['emailAddress'] || '';
			this.lastName = obj['lastName'] || '';
			this.postalCode = obj['postalCode'] || '';
			this.state = obj['state'] || '';
			this.status = obj['status'] || '';
			this.telephoneNumber = obj['telephoneNumber'] || '';
			this.mobileNumber = obj['mobileNumber'] || '';
			this.isUserActive = obj['isUserActive'] || '';
		}
	}
}	


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/agent.model.ts